import { LearningPathResourceResponseApi } from "../../ServerResponseType/LearningPath/LearningPathResource";

export interface LearningPathResourceRequestApi {
  learningPathResourceId: string;
  resourceId: string;
}

export class LearningPathResourceRequestImpl
  implements LearningPathResourceRequestApi
{
  learningPathResourceId: string;
  resourceId: string;

  constructor(learningPathResource: LearningPathResourceResponseApi) {
    this.learningPathResourceId = learningPathResource.learningPathResourceId;
    this.resourceId = learningPathResource.resource.resourceId;
  }
}
